"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
  Currently there's no types for quill modules,
  so you need to either make types, or use a js
  file to import them (which is what setup.js is).
*/
var setup_1 = __importDefault(require("./setup"));
var fullToolbarOptions = [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic"],
    ["clean"],
    ["image"],
    [{ list: "ordered" }, { list: "bullet" }],
];
console.log("Demo loaded...");
var quill = new setup_1.default("#editor", {
    theme: "snow",
    modules: {
        toolbar: {
            container: fullToolbarOptions,
        },
        htmlEditButton: { debug: true, syntax: true },
    },
});
